<template>
  <div>

    <div v-if="show">

      <div :style="containerTableStyle">

        <div v-if="busy" class="table-busy"></div>

        <table class="mb-0 table table-hover"
               :class="{'table-striped':tableStriped,'table-responsive':tableResponsive,'table-bordered':tableBordered, 'table-input-enabled': (enableRadio || enableChecked) &&  (command === 'insert' || command === 'update')}"
               :aria-busy="busy">
          <thead>
          <tr>
            <th v-if="(enableRadio || enableChecked) && (command === 'insert' || command === 'update')">

              <div class="d-flex align-content-center justify-content-center">

                <b-form-checkbox class="table-checked-all"
                                 v-if="enableChecked && onItems.length > 0"
                                 @change="selectAllItems()"
                                 :checked="onItems.length === valueChecked.length && valueChecked.length > 0"
                                 v-b-tooltip.hover.ds500 title="Marcar ou Desmarcar todos"
                                 :indeterminate="onItems.length !== valueChecked.length && valueChecked.length > 0"/>

              </div>


            </th>
            <th v-for="(field) in fields" :key="field.key" style="vertical-align: top;" :class="{'table-head-search':enableSearch,[field.headerClass]:field.headerClass && field.headerClass !== ''}">


              <div v-if="enableSearch && (command === 'insert' || command === 'update') && checkShowSearch(field)">
                <t-input style="max-width: 250px"
                         :money="field.formatter && field.formatter === 'money'"
                         :percent="field.formatter && field.formatter=== 'percent'"
                         :help="field.help"
                         v-model="field.search" :label="field.label"/>
              </div>
              <div v-else class="d-flex">
                {{ field.label }}
                <t-help v-if="field.help !== undefined && field.help !== ''" :title="field.help"/>
              </div>

            </th>
            <th v-if="!disableActionsColumn"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in paginatedItems" :key="index" :class="item.class"
              :style="checkBackgroundLine(item[localPrimaryKeyArrayIds])">

            <td v-if="(enableRadio || enableChecked) &&  (command === 'insert' || command === 'update')"
                style="width: 50px; text-align: center">

              <b-form-radio v-if="enableRadio" :name="localTitleItems+'_RADIO'" v-model="valueRadio"
                            :value="item[localPrimaryKeyArrayIds]"></b-form-radio>
              <b-form-checkbox
                  v-else
                  v-model="valueChecked"
                  :value="item[localPrimaryKeyArrayIds]"
              />


            </td>

            <td @click="onLineClick(item[localPrimaryKeyArrayIds])" class="input-hover">

              <slot name="first-column" :item="item" :index="index">

                <t-list-link-primary v-if="!disableLinkPrimaryColumn"
                                     :formatter="fields.find(a => a.key === linkPrimaryColumn).formatter"
                                     :label="item[linkPrimaryColumn]" :userAuth="userAuth" :id="item[primaryKeyColumn]"
                                     :path="userAuth.currentPage.path"/>

                <span v-else>{{ item[linkPrimaryColumn] }}</span>
              </slot>

            </td>

            <td v-for="(field) in fields.filter(a => a.key !== linkPrimaryColumn)" :key="field.key"
                @click="onLineClick(item[localPrimaryKeyArrayIds],field.key)" :class="[field.lineClass, { 'input-hover': !disableColumnsClick.includes(field.key) }]">
              <slot :name="'item(' + field.key + ')'" :item="item" :index="index">
                <t-table-field :column="field.key" :formatter="field.formatter" :item="item"/>
              </slot>
            </td>

            <td v-if="!disableActionsColumn">

              <slot name="actions" :item="item">
                <div class="d-flex listActions justify-content-end">
                  <slot name="append-actions" :item="item"></slot>

                  <t-list-actions-default @reload="reload()" :delete-by-confirm-id="item[deleteByConfirmColumn]"
                                          :form-path="userAuth.currentPage.path" :id="item[primaryKeyColumn]"
                                          :userAuth="userAuth"/>

                </div>

              </slot>
            </td>
          </tr>
          </tbody>
        </table>

      </div>

      <!--Paginação interna da tabela de listgem nunca monta link somente retorna o número da página clicada-->
      <b-row v-if="totalPages > 0" class="mt-3">

        <b-col cols="6">
          <t-pagination v-if="totalPages > 1" @getPage="clickPage" not-link-gen
                        :total-pages="totalPages"></t-pagination>
        </b-col>
        <b-col :cols="totalPages === 1 ? 12 : 6" v-if="totalElements > 0" class="text-right mt-2">
          <small>Total {{ totalElements }} {{ localTitleItems }}</small>
        </b-col>
      </b-row>

      <!-- Paginação -->

      <b-row v-if="enablePagination && totalPagesComputed > 1" class="mt-3">
        <b-col class="d-flex justify-content-center">

          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="pageSize"
              @input="changePage"
              align="center"
          ></b-pagination>
        </b-col>
      </b-row>

      <!--
            <b-row v-else-if="enablePagination && totalPagesComputed > 1" class="mt-3">
              <b-col class="d-flex justify-content-between">
                <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1" class="btn btn-sm btn-primary">Anterior</button>
                <span>Página {{ currentPage }} de {{ totalPagesComputed }}</span>
                <button @click="changePage(currentPage + 1)" :disabled="currentPage >= totalPagesComputed" class="btn btn-sm btn-primary">Próximo</button>
              </b-col>
            </b-row>-->

    </div>

    <t-msg v-else warning>

      <span v-if="filtered">Nenhum registro encontrado para o filtro informado!</span>
      <span v-else>Nenhum registro cadastrado!</span>

    </t-msg>

  </div>
</template>
<script>

export default {
  name: 't-table',
  data() {
    return {
      localTitleItems: "",
      localPrimaryKeyArrayIds: "",
      checkedAll: false,
      indeterminate: true,
      valueRadio: 0,
      valueChecked: [],
      colorLineSelected: "#f1faff", //Cor padrão quando selecionado
      currentPage: 1, // Página atual

    }
  },
  props: {
    enablePagination: {type: Boolean, default: false}, // Habilita paginação
    enableRadio: Boolean,//Habilita escolha única
    enableChecked: Boolean,//Habilita escolha multipla
    pageSize: {type: Number, default: 20},
    fields: Array,
    command: {
      type: String,
      default: 'insert'
    },
    userAuth: Object,
    items: Array,
    containerTableStyle: Array,
    tableResponsive: Boolean,
    tableBordered: Boolean,
    tableStriped: Boolean,
    show: {
      type: Boolean,
      default: true,
    },
    filtered: Boolean,
    busy: Boolean,
    primaryKeyColumn: String,
    primaryKeyArrayIds: {
      type: String,
      default: ""
    },
    deleteByConfirmColumn: {
      type: String,
      default: ""
    },
    titleItems: {
      type: String,
      default: ""
    },
    totalPages: {
      type: Number,
      default: 0
    },
    totalElements: {
      type: Number,
      default: 0
    },
    linkPrimaryColumn: {
      type: String,
      default: "name"
    },
    disableLinkPrimaryColumn: {
      type: Boolean,
      default: false
    },
    disableActionsColumn: {
      type: Boolean,
      default: false
    },
    enableSearch: {
      type: Boolean,
      default: false
    },
    disableSearch: {
      type: Array,
      default: () => [],
    },
    disableColumnsClick: {
      type: Array,
      default: () => [],
    },
    value: {
      type: null,
      default: ""
    },
  },
  mounted() {

    this.setValue(this.value)

    if (this.primaryKeyArrayIds !== '') {
      //Especificado uma coluna id diferente do padrão de leitura para utilização de ações em massa
      this.localPrimaryKeyArrayIds = this.primaryKeyArrayIds
    } else {
      this.localPrimaryKeyArrayIds = this.primaryKeyColumn
    }

    if (this.titleItems !== '') {
      this.localTitleItems = this.titleItems
    } else {

      if (this.userAuth && this.userAuth.currentPage && this.userAuth.currentPage.singularTitle) {
        this.localTitleItems = this.userAuth.currentPage.singularTitle + "s"
      } else {
        this.localTitleItems = 'registros'
      }
    }

  },
  methods: {

    checkShowSearch(field) {

      let show = true

      if (this.disableSearch.length > 0) {

        if (this.disableSearch.includes(field.key))
          show = false

      }

      return show

    },

    selectAllItems() {

      //Condição para remoção geral, será somente se todos estiverem marcados
      if (this.onItems.length === this.valueChecked.length && this.valueChecked.length > 0) {
        //Remover todos
        this.valueChecked = []

      } else {
        //Selecionar todos

        this.valueChecked = []

        for (const item of this.onItems) {
          this.valueChecked.push(item[this.localPrimaryKeyArrayIds])
        }

      }
    },

    checkBackgroundLine(id) {

      let style = {}

      if (this.command === 'insert' || this.command === 'update') {

        if (this.enableChecked) {
          if (this.valueChecked.includes(id)) {
            style.backgroundColor = this.colorLineSelected
          }


        } else if (this.enableRadio) {
          if (this.valueRadio === id) {
            style.backgroundColor = this.colorLineSelected
          }


        }

      }


      return style
    },

    onLineClick(id,column = '') {

      if(column !== '' && this.disableColumnsClick.includes(column))
        return


      if (this.enableChecked && (this.command === 'insert' || this.command === 'update')) {

        if (this.valueChecked.includes(id)) {
          //Já existe por tanto remover
          const indexRemove = this.valueChecked.indexOf(id);
          this.valueChecked.splice(indexRemove, 1);

        } else {
          //Não existe, por tanto adicionar
          this.valueChecked.push(id)
        }

      } else if (this.enableRadio) {
        this.valueRadio = id
      }


    },

    setValue(v) {
      if (this.enableRadio) {
        this.valueRadio = v
      } else {
        this.valueChecked = v
      }

    },

    reload() {
      this.$emit("reload")
    },

    clickPage(page) {
      this.$emit('getPage', page)
    },
    removeAccentuation(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },

    changePage(page) {

      if (page > 0 && page <= this.totalPagesComputed) {
        this.currentPage = page;
      }
    }

  },
  watch: {
    value(v) {
      this.setValue(v)
    },

    valueChecked(v) {

      this.$emit("input", v)
      this.$emit("change", v)

    },

    valueRadio(v) {
      this.$emit("input", v)
      this.$emit("change", v)
    }
    /*modalSearch(v) {

    }*/

  },
  computed: {

    totalPagesComputed() {
      return this.enablePagination ? Math.ceil(this.onItems.length / this.pageSize) : 1;
    },
    paginatedItems() {
      if (!this.enablePagination) return this.onItems;
      const start = (this.currentPage - 1) * this.pageSize;
      return this.onItems.slice(start, start + this.pageSize);
    },

    onItems() {

      if (this.command === 'view' || this.command === 'delete') {
        return this.items.filter(item => this.valueChecked.includes(item[this.localPrimaryKeyArrayIds]))
      } else {

        let filteredItems = this.items

        for (const field of this.fields) {

          if (field.search !== undefined && field.search !== '') {

            if (field.formatter !== undefined && field.formatter !== '' && (field.formatter === 'money' || field.formatter === 'percent')) {

              if (field.search > 0) {

                filteredItems = filteredItems.filter(item => {
                  const itemValue = item[field.key];
                  return itemValue.toString().includes(field.search);
                });

              }

            } else {


              // Remove acentuação da busca
              const searchValue = this.removeAccentuation(field.search).toLowerCase();

              // Aplica o filtro para cada campo com 'search' preenchido
              filteredItems = filteredItems.filter(item => {
                const itemValue = item[field.key] ? this.removeAccentuation(item[field.key]).toLowerCase() : '';
                return itemValue.includes(searchValue);
              });


            }


          }
        }

        return filteredItems


      }


    }

  }
}
</script>
<style>
.table-checked-all .custom-control-label:before {
  border-color: #00a1ee;
  background-color: #7ecffc;

}

.table-checked-all .custom-control-input:checked ~ .custom-control-label::before, .table-checked-all .custom-control-input:indeterminate ~ .custom-control-label::before {
  color: #fff;
  border-color: #00a1ee !important;
  background-color: #0075b0 !important;
}

.table-input-enabled tbody .input-hover:hover {
  cursor: pointer;
}

</style>